module.exports = __webpack_public_path__ + "static/media/logo.47d9c817.png";